import { DataHistory, DataModel } from '@shared/models/data-model';
import { LastUsedAuthenticationMethod } from '@shared/enum/last-used-authentication-method';
import { AccountCreationMethod } from '@shared/enum/account-creation-method';
import { UserData } from '@/app/platform/platform-shared/models/types';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';

export class UserAccountEntity extends DataModel implements UserData {
  constructor(
    id: string,
    meta: Partial<DataHistory>,
    public userName: string,
    public displayName: string,
    public firstName: string,
    public lastName: string,
    public badgeId: string,
    public primeTimeId: string,
    public email: string,
    public hasAcceptedTerms: boolean,
    public lastAcceptedTermsOn: string,
    public isVerified: boolean,
    public verifiedOn: string,
    public lastUsedAuthenticationMethod: LastUsedAuthenticationMethod,
    public accountCreationMethod: AccountCreationMethod,
    public groupIds: string[]
  ) {
    super(id, meta);
  }

  isMemberOf(group: UserGroupEntity): boolean {
    return this.groupIds.includes(group.id);
  }

  static createDefault(name: string, id = ''): UserAccountEntity {
    return new UserAccountEntity(
      id,
      {},
      name,
      name,
      name,
      name,
      '',
      '',
      '',
      true,
      '',
      true,
      '',
      0,
      0,
      []
    );
  }
}
